import { Component, Input } from '@angular/core';
import { SettlementPeriod } from '@models/insurance-type';
import { DisplayPriceComponent } from 'app/shared/components/display-price/display-price.component';

@Component({
    selector: 'app-inline-price-display',
    templateUrl: './inline-price-display.component.html',
    styleUrls: ['./inline-price-display.component.scss'],
    imports: [DisplayPriceComponent],
})
export class InlinePriceDisplayComponent {
    @Input({ required: true })
    public price: number;
    @Input({ required: true })
    public settlementPeriod: SettlementPeriod;
    @Input({ required: true })
    public taxInfo: string;
}
